module.exports = __webpack_public_path__ + "static/HopeForPaws-aefb6660a93b4639f4b3f67d6131f821.png";